import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardContent } from '@mui/material';

const CardV2 = ({ children, title }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        mt: 2.5,
        borderRadius: 1,
      }}
    >
      <CardHeader
        title={title}
        sx={{
          bgcolor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.neutral[100]
              : theme.palette.neutral[800],
          '& .MuiCardHeader-title': {
            fontSize: '1rem',
          },
        }}
      />
      <CardContent sx={{ p: 2 }}>
        {children}
      </CardContent>
    </Card>
  );
};

CardV2.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
};

export default CardV2;
